import { render, staticRenderFns } from "./ButtonOutlined.vue?vue&type=template&id=a0f4be72&scoped=true"
import script from "./ButtonOutlined.vue?vue&type=script&lang=ts"
export * from "./ButtonOutlined.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4be72",
  null
  
)

export default component.exports